export default {
  combination: ['start', 'combinationStart', 'type', 'parameters', 'misc', 'status', 'combinationSummary']
}
